import type { FC, SVGProps } from "react";

import {
	Activity,
	MarkerPin01,
	Microphone01,
	VideoRecorder,
	Wind01,
} from "@untitledui/icons";

type SensorTypeIcon = FC<SVGProps<SVGSVGElement>>;

/** Shared with map pins and sidebar rows so type icons stay in sync. */
export const SENSOR_TYPE_ICON_MAP: Record<string, SensorTypeIcon> = {
	air_quality: Wind01,
	camera: VideoRecorder,
	motion: Activity,
	sound: Microphone01,
};

/** Icon for a sensor type string (map pins and sidebar rows). */
export const getSensorTypeIcon = (type: string | undefined): SensorTypeIcon => {
	if (!type) return MarkerPin01;
	return SENSOR_TYPE_ICON_MAP[type.toLowerCase()] ?? MarkerPin01;
};
